import moment from 'moment'
import React, { useState } from 'react'
import {
  AssessmentSvg,
  IconEditSvg,
  IconTrashSvg
} from '../../../assets/icons/svgComponents'
import * as S from '../style'
import 'moment/locale/pt-br'
import theme from '../../../styles/theme'
import { CustomerModel, ServiceModelDto } from '../../../../domain/models'
import ItemAssesmentCard from './item-assesment'
import { AssessmentModel } from '../../../../domain/models/assessment'
import DeleteAssessmentModal from '../../accordion-table/delete-assesment'
import { useModalBox } from '../../../contexts'
import AssesmentForm from '../../../components/timeline/modal/assesment'

type AccordionTableProps = {
  handleOpenEditModal: any
  idCustomer: string | number
  assessment: AssessmentModel
  service: ServiceModelDto
  patient: CustomerModel | undefined
}

const AssesmentCard = ({
  handleOpenEditModal,
  idCustomer,
  assessment,
  patient,
  service
}: AccordionTableProps): JSX.Element => {
  const { modalBox } = useModalBox()
  const [openActions, setOpenActions] = useState<boolean>(false)
  const handleOpenDeleteServiceModal = () => {
    modalBox(
      <DeleteAssessmentModal item={assessment} />,
      'Deletar Fato Relevante',
      '35%'
    )
  }

  const handleOpenAssessmentModal = () => {
    if (assessment) {
      modalBox(
        <AssesmentForm
          value={patient}
          service={service}
          assessment={assessment}
        />,
        'Validação de dados',
        '46%'
      )
    }
  }
  return (
    <div>
      {/* {rows?.map((item: ServiceModel) => ( */}
      <S.ContainerCard
        key={assessment.cdAvaliacaoPsicologica}
        color={theme.colors.pink}
      >
        <S.IconTop color={theme.colors.pink}>
          <AssessmentSvg outlined />
        </S.IconTop>
        <S.Title>
          {assessment.demanda}
          <S.Options
            onClick={() => {
              setOpenActions((prev: boolean) => !prev)
            }}
          >
            {openActions && (
              <S.DropdownAction>
                <span>
                  <S.ActionButtonCard
                    onClick={() => handleOpenAssessmentModal()}
                  >
                    <IconEditSvg /> Editar
                  </S.ActionButtonCard>
                  <S.ActionButtonCardCancel
                    onClick={() => handleOpenDeleteServiceModal()}
                  >
                    <IconTrashSvg /> Excluir
                  </S.ActionButtonCardCancel>
                </span>
              </S.DropdownAction>
            )}
            ...
          </S.Options>
        </S.Title>
        <S.SubTitle>
          {moment(assessment.dataFinal)
            .locale('pt-br')
            .format('DD [de] MMMM [de] YYYY')}
        </S.SubTitle>

        <ItemAssesmentCard
          item={assessment}
          key={assessment.cdAvaliacaoPsicologica}
          handleOpenEditModal={handleOpenEditModal}
          idCustomer={idCustomer}
          service={service}
        />
      </S.ContainerCard>
      {/* ))} */}
    </div>
  )
}
export default AssesmentCard
